<template>
  <div>
    <div class="all-questions-container">
      <div class="question-container" v-for="question in questions" :key="question.QuestionID">
        <ShortAnswerQuestion v-if="question.QuestionType === 'short answer'" :question="question" />
        <LikertTypeQuestion v-if="question.QuestionType === 'likert-type'" :question="question" />
      </div>
    </div>
  </div>
</template>

<script>
import ShortAnswerQuestion from "./ShortAnswerQuestion.vue";
import LikertTypeQuestion from "./LikertTypeQuestion.vue";

export default {
  props: {
    questions: {
      type: Object,
      required: true
    },
    formName: {
      type: String,
      required: true
    }
  },
  components: {
    ShortAnswerQuestion,
    LikertTypeQuestion
  }
};
</script>

<style scoped>
</style>